/**
 * Is this keystroke going into something the user is TYPING in?
 *
 * The global shortcut handler has always skipped `INPUT` / `TEXTAREA` /
 * `SELECT` by tag name, which was complete while every writing surface in the
 * app was one of those three. It is not any more: `EmailRichTextEditor` is
 * Lexical, so the compose body is a `contenteditable` DIV and a tag-name check
 * waves every shortcut straight through it.
 *
 * ⚠️ THAT STOPPED BEING THEORETICAL WITH `[` (tracker row 67). `g`, `n` and `?`
 * are rare enough mid-sentence to have hidden the gap; a square bracket is a
 * character people actually type, and pressing one while writing an email would
 * have collapsed the sidebar under them. Fixing the predicate rather than
 * special-casing the new key also closes it for the three that were already
 * exposed.
 *
 * `isContentEditable` is inherited down the DOM, so it answers for a caret
 * inside a nested node too; the `closest` arm is for a target that is an
 * Element without the HTMLElement property (an inline SVG, say).
 */
export function isTypingTarget(target: unknown): boolean {
  if (!target || typeof target !== 'object') return false
  const el = target as { tagName?: unknown; isContentEditable?: unknown; closest?: unknown }

  const tag = typeof el.tagName === 'string' ? el.tagName.toUpperCase() : ''
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true

  if (el.isContentEditable === true) return true

  if (typeof el.closest === 'function') {
    return !!(el.closest as (s: string) => unknown)('[contenteditable="true"], [contenteditable=""]')
  }
  return false
}
